let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fUlKa")).then(() => parcelRequire('dTOtT'));